import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { renderMarkup } from "../utils.js";

class Hero extends Component {
  render() {
    const { image, linkTitle, linkUrl, content } = this.props;
    if (image) {
      const HeroContainer = styled.div`
        background-image: url(${image});
        background-size: cover;
        background-position: center;
        height: 668px;
        display: flex;
        margin-top: 70px;
        align-items: center;
        text-align: center;
        position: relative;
        overflow: hidden;
        .container {
          position: relative;
          z-index: 1;
          color: white;
          text-shadow: 1px 1px 15px rgba(0, 0, 0, 0.7);
          width: 90%;
          font-size: 1.5em;
          max-width: 500px;
          p {
            font-size: 1em;
            line-height: 1.2;
            color: white;
          }
        }
        @media screen and (min-width: 1024px) {
          .container {
            text-align: left;

            margin: initial;
            margin-left: 100px;
          }
        }
      `;
      return (
        <HeroContainer>
          <div className="container">
            <div dangerouslySetInnerHTML={renderMarkup(content)} />
            {this.props.linkTitle && (
              <Link to={linkUrl} className="btn main">
                {linkTitle}
              </Link>
            )}
          </div>
          <div className="overlay" />
        </HeroContainer>
      );
    } else return false;
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js